import { render, staticRenderFns } from "./PublisherLogo.vue?vue&type=template&id=1a97e02a&scoped=true&lang=pug&"
import script from "./PublisherLogo.vue?vue&type=script&lang=js&"
export * from "./PublisherLogo.vue?vue&type=script&lang=js&"
import style0 from "./PublisherLogo.vue?vue&type=style&index=0&id=1a97e02a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97e02a",
  null
  
)

export default component.exports